import React from "react"
import PropTypes from "prop-types"
import _groupBy from "lodash/groupBy"
import { Box, TextSM, Link, Select } from "datastory-shared/ui"

const GroupUI = ({
  indicators,
  exampleIndicators,
  indicator,
  onSetIndicator,
}) => {
  const options = Object.entries(_groupBy(indicators, d => d.category)).map(
    d => ({ label: d[0], options: d[1] })
  )
  return (
    <Box data-cy="hypotheticalriksdag-group-selector">
      <Select
        size="large"
        style={{
          width: "100%",
          maxWidth: "420px",
          margin: "0 auto",
          textAlign: "left",
        }}
        value={indicator}
        onChange={onSetIndicator}
        options={options}
        showSearch
      />
      {exampleIndicators && (
        <TextSM mt="lg" data-cy="hypotheticalriksdag-example-indicators">
          {"Genvägar: "}
          {exampleIndicators.map((indicator, i) => (
            <TextSM as="span" key={indicator.id}>
              <Link
                variant="standalone"
                href={"/services/hypothetical-riksdag-sweden"}
                onClick={e => {
                  e.preventDefault()
                  onSetIndicator(indicator.id)
                }}
              >
                {indicator.name}
              </Link>
              {i !== exampleIndicators.length - 1 && " | "}
            </TextSM>
          ))}
        </TextSM>
      )}
    </Box>
  )
}

GroupUI.propTypes = {
  indicator: PropTypes.string.isRequired,
  indicators: PropTypes.array.isRequired,
  exampleIndicators: PropTypes.array,
  onSetIndicator: PropTypes.func,
}

export default GroupUI
